import { FC } from 'react'
import { isAfter } from 'date-fns'
import { Format, Parse, FormatOptions } from 'services/Dates'

import { t } from 'translations'

const EmailStatus: FC<MData.User['onboarding']> = ({
  accepted,
  acceptedDate,
  bounced,
  clicked,
  delivered,
  deliveredDate,
  dropped,
  failed,
  failedDate,
  failedMessage,
  opened,
  openedDate,
  timeZone
}) => {
  const wasOpened = (opened || clicked) && !(failed || bounced || dropped)
  const wasDelivered = delivered && !(opened || clicked) && !(failed || bounced || dropped)
  const hasFailed = !delivered && !(opened || clicked) && !(failed || bounced || dropped)

  const options: FormatOptions = { isUTC: true, timeZone, outFormat: 'dateTime' }

  if (wasOpened)
    return (
      <span className="text-success">
        <i className="fas fa-envelope-open green-icon mr-1" />
        {t('manager.users.onboarding.OPENED', { date: openedDate ? Format(openedDate, options) : 'N/A' })}
      </span>
    )

  if (wasDelivered)
    return (
      <span className="text-success">
        <i className="fas fa-envelope mr-1" />
        {t('manager.users.onboarding.DELIVERED', { date: deliveredDate ? Format(deliveredDate, options) : 'N/A' })}
      </span>
    )

  if (hasFailed && isAfter(Parse(acceptedDate), Parse(failedDate)))
    return (
      <span className="text-danger">
        <i className="fas fa-envelope red-icon mr-1" />
        {t(failedMessage, { date: failedDate ? Format(failedDate, options) : 'N/A' })}
      </span>
    )

  if (accepted)
    return (
      <span className="text-success">
        <i className="fas fa-envelope mr-1" />
        {t('manager.users.onboarding.SENT', { date: acceptedDate ? Format(acceptedDate, options) : 'N/A' })}
      </span>
    )
  // No status to display
  return null
}

export default EmailStatus
